import BaseKPI from "./BaseKPI";
export default BaseKPI;
